<template>
  <v-container>
    <v-row :class="left ? 'justify-end' : 'justify-start'">
      <label class="v-label mt-2 mr-4"> {{ left ? label : '' }}</label>
      <v-switch
        :id="`signer_switch__item`+$attrs.index+`__switch`"
        v-model="valueMe"
        :dense="dense"
        :inset="inset"
        :hide-details="hideDetails"
        :loading="loading"
        :disabled="loading"
        :readonly="readonly"
        :color="readonly ? 'grey' : 'teal accent-4'"
        class="mt-0"
        :label="left ? '' : label"
      ></v-switch>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'SignerSwitch',
  props: {
    value: { type: Boolean, default: false },
    label: { type: String, default: '' },
    dense: { type: Boolean, default: false },
    inset: { type: Boolean, default: false },
    hideDetails: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    readonly: { type: Boolean, default: false },
    left: { type: Boolean, default: false }
  },
  computed: {
    valueMe: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
        this.$emit('onChange', value)
      }
    }
  }
}
</script>
